import React, { Fragment, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import MainFilter from "../components/filters/MainFilter";
import heatmapImage from "../assets/img/heatmap.png";
import heatmapRange from "../assets/img/HeatmapRanges.png";
import { heatmapRequest } from "../helpers/requests";
import Heatmap from "./Templates/Heatmap";
import {
  setHeatmapFilter,
  setHeatmapLoader,
  setHeatmap,
} from "../redux/actions/heatmapActions";
import { Card, CardBody, Row, Col } from "reactstrap";

const Heatmaps = () => {
  const [filters, setFilters] = useState();

  const [currentStore, setcurrentStore] = useState()
  // const [heatmap_type, setHeatmap_type] = useState("Customer");
  const dispatch = useDispatch();
  const heatmap = useSelector((state) => state?.heatmapReducer?.data);
  var filter = useSelector((state) => state?.heatmapReducer?.filter);
  console.log("filterShow",filter);
  console.log('arslanFilter',filters);
  var loader = useSelector((state) => state.heatmapReducer.loader);
  const user = useSelector((state) => state.auth.user);
  const [showMap, setShowMap] = useState(true);
  const [mapType, setMapType] = useState(1);
  const stores = user.access.map((val, index) => {
    return { ...val, value: val._id, label: val.label };
  });
const [floor, setfloor] = useState();

console.log('Xfloors',floor);
  var floors = [];
  if (stores.length) {
    floors = stores[0].floors.map((val, index) => {
      return { ...val, value: val._id, label: val.floor_label };
    });
  }

  const setStore = (store) => {
    let tempFloors = store.floors.map((val, index) => {
      return { ...val, value: val._id, label: val.floor_label };
    });
    loadNewMap(tempFloors[0]._id, store._id);
    dispatch(
      setHeatmapFilter({
        ...filter,
        store: store,
        stores: stores,
        floor: tempFloors[0],
        floors: tempFloors,
        type: null,
      })
    );
  };
  
  const updateFilter = (e) => {
    setFilters(e);
    var requestData = {
      params: e,
      dispatch,
    };
    heatmapRequest(requestData);
    
  };
  
  useEffect(() => {
    if(filters){
    let store =stores.filter(store =>{
      return store._id === filters.sid
    })
    
    setcurrentStore(store[0]);
  }
   
  }, [filters])
  

  const setFloor = (floor) => {
    loadNewMap(floor._id);
    dispatch(setHeatmapFilter({ ...filter, floor: floor, type: null }));
  };

  const loadNewMap = (fid = null, sid = null, start = null, end = null) => {
    dispatch(setHeatmap([]));
    setShowMap(false);
    setTimeout(() => {
      setShowMap(true);
      getHeatmap(fid, sid, start, end);
    }, 200);
  };

  const getHeatmap = (fid = null, sid = null, start = null, end = null) => {
    var requestData = {
      params: {
        fid: fid ? fid : filter.floor ? filter.floor.value : floors[0].value,
        sid: sid ? sid : filter.store ? filter.store.value : stores[0].value,
        start: start ? start : filter.start,
        end: end ? end : filter.end,
      },
      dispatch: dispatch,
    };
    dispatch(setHeatmapLoader(true));
    // heatmapRequest(requestData);
    setTimeout(()=>{
      dispatch(setHeatmap(requestData));
    }, 500);
  };


  useEffect(() => {
    {currentStore&&
    setStore(stores.length ? currentStore : null)
    }
    setTimeout(() => {
      getHeatmap();
    }, 200);
  }, [currentStore]);

  useEffect(() => {
    setStore(stores.length ? stores[0] : null);
    setTimeout(() => {
      getHeatmap();
    }, 200);
  }, []);

  useEffect(() => {
    if(filters)
 {
  var flag = filter?.floors.filter(item =>{ return item._id === filters.fid
  })[0]
  setfloor(flag);
 }
  }, [filters])

  return (
    <Fragment>
      <MainFilter
        pageTitle="Heatmaps"
        noRange={true}
        updateFilter={(e) => updateFilter(e)} 
        type='gold'
      ></MainFilter>
   
      <Row className="mb-3">
        <Col>
          <Card>
            <CardBody>
              
              <Row className="align-items-center justify-content-evenly">
                <Col className="col-9 col-md-9">
                  {filter.store !== null && showMap && mapType == 1 && (
                    <Heatmap
                      // dye={filter.floor ? filter.floor.dye_image : ""}
                      dye={floor ? floor.dye_image : ""}
                      // map={filter.floor ? filter.floor.image : ""}
                      map={floor ? floor.image : ""}
                      heatmapData={heatmap}
                      //  sections={filter.floor?filter.floor.sections: []} key={ "my_map" }
                      sections={floor?floor.sections: []} key={ "my_map" }
                    />
                  )}
                </Col>
                <Col className="col-3 col-md-3">
                  <img src={heatmapRange} className="rounded" />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {false && (
        <>
          <Card>
            <CardBody>
              <Row>
                <Col className="h-100 valign-middle">
                  <h5 className="font-italic">
                    "A picture is worth a thousand words"
                  </h5>
                </Col>
              </Row>
              <Row>
                <Col>
                  <img src={heatmapImage} className="rounded w-100" />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </>
      )}
    </Fragment>
  );
};

export default Heatmaps;
